module.exports = __webpack_public_path__ + "static/media/ideal_logo.55eb36b4.svg";